<template>
  <v-card flat class="futuristic-card">
    <div class="card-header">
      <h1 class="earth-color">VAT HISTORY</h1>
      <div class="title-decoration"></div>
    </div>
    <v-card-title class="search-container">
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        placeholder="Search"
        single-line
        hide-details
        v-model="search"
        class="futuristic-search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="allVats"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear slot="progress" color="#587e27" indeterminate height="3"></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.index + 1 }}</td>
        <td class="font-weight-medium">{{ props.item.vat_rate }} %</td>
        <td>{{ formated_date(props.item.start_date) }}</td>
        <td>{{ formated_date_time(props.item.created_at) }}</td>
        <td>{{ props.item.user }}</td>
      </template>
      <v-alert slot="no-results" :value="true" color="#f44336" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
      <template slot="no-data">
        <div class="text-xs-center py-4">
          No VAT history available
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      columns: [
        { text: '#', value: '', sortable: false, class: 'table-header' },
        { text: 'VAT Amount', value: 'vat_rate', class: 'table-header' },
        { text: 'Start Date', value: 'start_date', class: 'table-header' },
        { text: 'Updated Date', value: 'created_at', class: 'table-header' },
        { text: 'Updated By', value: 'user', class: 'table-header' }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_all_vats')
  }
}
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.search-container {
  padding: 16px;
  background: #f9f9f9;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 0 12px;
  margin-bottom: 0;
}

.futuristic-search >>> .v-input__icon .v-icon {
  color: #587e27;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .search-container {
    padding: 8px;
  }
}
</style>